import React from "react";
import { FaHandshake, FaTools, FaTruck, FaPhone } from "react-icons/fa";

const AboutUs = () => {
  return (
    <section className="about-us py-16 bg-gray-50">
      <div className="container mx-auto px-8 md:px-16">
        {/* Section Title */}
        <h2 className="text-4xl font-bold text-center text-gray-800 mb-12">
          About Us
        </h2>

        {/* About Description */}
        <div className="flex flex-col md:flex-row gap-12 items-center justify-center">
          <div className="md:w-1/2 text-lg text-gray-700 space-y-6 text-center md:text-left">
            <p>
              At{" "}
              <span className="font-bold text-burgundy">
                Imperium Auto Group
              </span>
              , we’re your go-to experts for all things automotive. With over{" "}
              <span className="highlight font-semibold">
                20+ years of experience
              </span>
              , we bring you a wealth of knowledge, expertise, and a commitment
              to delivering{" "}
              <span className="highlight font-semibold">
                top-notch vehicle parts and services
              </span>{" "}
              at unbeatable prices.
            </p>
            <p>
              Our mission is to be your trusted partner in finding{" "}
              <span className="font-semibold">quality used vehicle parts</span>{" "}
              without the hefty price tag. Whether you’re in need of a reliable
              part or looking to sell your vehicle, you can trust us to offer{" "}
              <span className="highlight font-semibold">fair pricing</span> and
              a seamless process.
            </p>
          </div>

          {/* Image Section */}
          <div className="md:w-1/4 relative">
            <img
              src={`${process.env.PUBLIC_URL}/About.jpg`}
              alt="About Imperium Auto Group"
              className="w-full h-full object-cover rounded-lg shadow-lg"
            />
          </div>
        </div>

        {/* Values Section */}
        <div className="mt-16">
          <h3 className="text-3xl font-semibold text-gray-800 text-center mb-8">
            Why Choose Us?
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 justify-items-center">
            {/* Values Cards */}
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <FaHandshake className="text-4xl text-burgundy mx-auto mb-4" />
              <h4 className="text-xl font-semibold mb-2">Trusted Experience</h4>
              <p>
                We’ve built a reputation of trust, quality, and reliability with
                every part we sell and every client we serve.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <FaTools className="text-4xl text-burgundy mx-auto mb-4" />
              <h4 className="text-xl font-semibold mb-2">Quality Parts</h4>
              <p>
                All our vehicle spares are thoroughly inspected to ensure the
                highest standard for your vehicle's performance.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <FaTruck className="text-4xl text-burgundy mx-auto mb-4" />
              <h4 className="text-xl font-semibold mb-2">
                Nationwide Delivery
              </h4>
              <p>
                We offer fast, reliable delivery services across the nation to
                get you the parts you need when you need them.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <FaPhone className="text-4xl text-burgundy mx-auto mb-4" />
              <h4 className="text-xl font-semibold mb-2">
                Exceptional Service
              </h4>
              <p>
                Our team is dedicated to providing excellent customer service to
                build long-lasting partnerships with all our clients.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
